import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SupportedDevice } from 'lavva.webbluetooth';
import { ROUTES } from '../../../../routes/routes';
import './index.scss';

type ProductListItemProps = {
  device: SupportedDevice;
  type: 'product' | 'more';
};

export const ProductListItem: React.FC<ProductListItemProps> = ({ device, type }) => {
  const navigate = useNavigate();

  const handleRedirect = () => navigate(ROUTES.StoreDeviceDetails(device.ModelGuid));

  return (
    <div className={`product-list-item ${type}`} onClick={handleRedirect}>
      <div className="image">
        {device.Pictures.length && <img src={device.Pictures[0]} alt="product image" width="100%" height="100%" />}
      </div>
      <p className="name">{device.Name}</p>
      <p className="model-name">{device.ModelName}</p>
    </div>
  );
};
